import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

interface IStyledSvgIcon {
  $isInteractive?: boolean;
  $isActive?: boolean;
  $activeColor?: string;
  $isDisabled?: boolean;
  $customFill?: string;
}

const interactiveStyles = css`
  &:hover {
    cursor: pointer;
    color: ${({ $activeColor }: { $activeColor?: string }) =>
      $activeColor || theme.colors.mainBlue};
    fill: ${({ $activeColor }: { $activeColor?: string }) =>
      $activeColor || theme.colors.mainBlue};
  }
`;

const activeStyles = css`
  color: ${({ $activeColor }: { $activeColor?: string }) =>
    $activeColor || theme.colors.mainBlue};
  fill: ${({ $activeColor }: { $activeColor?: string }) =>
    $activeColor || theme.colors.mainBlue};
`;

const disabledStyles = css`
  fill: ${theme.colors.secondary400};
  cursor: default;
`;

export const StyledSvgIcon = styled.svg<IStyledSvgIcon>`
  flex: 0 0 auto;
  fill: ${({ $customFill }) =>
    $customFill ? $customFill : theme.colors.secondary600};

  ${({ $isInteractive, $isDisabled }) =>
    !$isDisabled && $isInteractive && interactiveStyles}
  ${({ $isActive, $isDisabled }) => !$isDisabled && $isActive && activeStyles}
  ${({ $isDisabled }) => $isDisabled && disabledStyles}
`;
